<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Pembuatan DBKB Non Standar</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <select class="form-control" v-model="tab">
                            <option>JPB 2</option>
                            <option>JPB 3</option>
                            <option>JPB 4</option>
                            <option>JPB 5</option>
                            <option>JPB 6</option>
                            <option>JPB 7</option>
                            <option>JPB 8A</option>
                            <option>JPB 8B</option>
                            <option>JPB 9</option>
                            <option>JPB 12</option>
                            <option>JPB 13</option>
                            <option>JPB 14</option>
                            <option>JPB 15</option>
                            <option>JPB 16</option>
                            <option>JPB MEZZANIN</option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
               <div v-if ="tab == 'JPB 2'">
                   <h3>Pemutakhiran DBKB JPB 2 - Perkantoran/Swasta</h3>
                   <bhumie_tab_jpb_2></bhumie_tab_jpb_2>
               </div>
               
               <div v-if ="tab == 'JPB 3'">
                   <h3>Pemutakhiran DBKB JPB 3 - Pabrik</h3>
                   <bhumie_tab_jpb_3></bhumie_tab_jpb_3>
               </div>

               <div v-if ="tab == 'JPB 4'">
                   <h3>Pemutakhiran DBKB JPB 4 Toko/Apotik/Pasar/Ruko</h3>
                   <bhumie_tab_jpb_4></bhumie_tab_jpb_4>
               </div>

               <div v-if ="tab == 'JPB 5'">
                   <h3>Pemutakhiran DBKB JPB 5 - Rumah Sakit/Klinik</h3>
                   <bhumie_tab_jpb_5></bhumie_tab_jpb_5>
               </div>

               <div v-if ="tab == 'JPB 6'">
                   <h3>Pemutakhiran DBKB JPB 6 - Olah Raga/Rekreasi</h3>
                   <bhumie_tab_jpb_6></bhumie_tab_jpb_6>
               </div>

               <div v-if ="tab == 'JPB 7'">
                   <h3>Pemutakhiran DBKB JPB 7 - Hotel</h3>
                   <bhumie_tab_jpb_7></bhumie_tab_jpb_7>
               </div>

               <div v-if ="tab == 'JPB 8A'">
                   <h3>Pemutakhiran DBKB JPB 8A - Bengkel/Gudang/Pertanian</h3>
                   <bhumie_tab_jpb_8A></bhumie_tab_jpb_8A>
               </div>

               <div v-if ="tab == 'JPB 8B'">
                   <h3>Pemutakhiran DBKB JPB 8B - Daya Dukung Bengkel/Gudang/Pertanian</h3>
                   <bhumie_tab_jpb_8B></bhumie_tab_jpb_8B>
               </div>

               <div v-if ="tab == 'JPB 9'">
                   <h3>Pemutakhiran DBKB JPB 9 - Gedung Pemerintahan</h3>
                   <bhumie_tab_jpb_9></bhumie_tab_jpb_9>
               </div>

               <div v-if ="tab == 'JPB 12'">
                   <h3>Pemutakhiran DBKB JPB 12 - Parkir</h3>
                   <bhumie_tab_jpb_12></bhumie_tab_jpb_12>
               </div>

               <div v-if ="tab == 'JPB 13'">
                   <h3>Pemutakhiran DBKB JPB 13 - Apartemen</h3>
                   <bhumie_tab_jpb_13></bhumie_tab_jpb_13>
               </div>

               <div v-if ="tab == 'JPB 14'">
                   <h3>Pemutakhiran DBKB JPB 14 - Pompa Bensin</h3>
                   <bhumie_tab_jpb_14></bhumie_tab_jpb_14>
               </div>

               <div v-if ="tab == 'JPB 15'">
                   <h3>Pemutakhiran DBKB JPB 15 - Tangki Minyak</h3>
                   <bhumie_tab_jpb_15></bhumie_tab_jpb_15>
               </div>

               <div v-if ="tab == 'JPB 16'">
                   <h3>Pemutakhiran DBKB JPB 16 - Gedung Sekolah</h3>
                   <bhumie_tab_jpb_16></bhumie_tab_jpb_16>
               </div>

               <div v-if ="tab == 'JPB MEZZANIN'">
                   <h3>Pemutakhiran DBKB JPB Mezzanin</h3>
                   <bhumie_tab_jpb_mezzanin></bhumie_tab_jpb_mezzanin>
               </div>



        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab: "JPB 2",
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
